export const lightThemePalette = {
  // Background Colors

  bgPrimary: '#ffffff',
  bgSecondary: '#f2f6fb',
  bgDisabled: '#cdd6de',

  // Text Colors

  textPrimary: '#1f2023',
  textSecondary: '#4a5b6b',
  textDisabled: '#718191',
  placeHolderText: '#707073',
  textSuccess: '#00a130',
  textInfo: '#237bf8',
  textError: '#ff2d39',

  // Border Colors

  borderPrimary: '#237bf8',
  borderDisabled: '#adb5bd80',
  borderSuccess: '#00a130',

  // Font family

  fontFamily: 'Muli, sans-serif',
};
